<template>
  <div id="app" class="app">
    <headbar v-if="$auth.isLogin"></headbar> <!-- <div v-else></div> -->
    <div class="syn-container">
      <router-view :toast="toast" :option="option"></router-view>
    </div>
    <mu-snackbar v-if="snackbar" :message="toastMessage" @actionClick="hideToast" @close="hideToast"/>
  </div>
</template>

<script>
import headbar from './component/Headbar.vue'
import snackbar from 'muse-components/snackbar'

export default {
  name: 'app',
  //props: ['msg'],
  data () {
    return {
      snackbar: false,
      toastMessage: '',
      option: {}
    }
  },
  components: {
      'mu-snackbar': snackbar,
      headbar

  },
  mounted: function (){
    let opt = ns.localStorage.get( APP_COD + "_cache" )
    if( opt !== null ){
      this.option = opt
    }
  },
  methods: {
    toast (msg) {
      if( msg !== undefined && msg.length > 0 ){
        this.toastMessage = msg
      } else {
        this.toastMessage = 'Fiche enregistré'
      }
      this.snackbar = true
      if (this.snackTimer) clearTimeout(this.snackTimer)
      this.snackTimer = setTimeout(() => { this.snackbar = false }, 2000)
    },
    hideToast () {
      this.snackbar = false
      if (this.snackTimer) clearTimeout(this.snackTimer)
    }
  }
}
</script>

<style lang="less">
/* Import de la personnalisation theme etc. */
/*@import "./config.less";*/
/* Personnalisation code */

html, body {
	margin: 0;
	height: 100%;
}
#app{
  min-height:100%;
  padding-top: 50px;
  height: 100%;
  width: 100%;
  min-height: 100%;
  position: relative;
}
.syn-container{
  width: 100%;
  min-height: 100%;
  height: 100%;
}

</style>


// WEBPACK FOOTER //
// App.vue?872631cc